import React, { useEffect, useState, } from 'react'
import { useNavigate, } from 'react-router-dom'
import { useDispatch, useSelector, } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { Helmet, } from "react-helmet"
import { appName, } from '../../../constants'
import { register, } from '../../../redux/actions/authActions'
import Loading from '../../layouts/Loading'

import "./RegisterComponent.scss"
import ErrorComponent from '../../layouts/ErrorComponent'

export default function RegisterComponent() {
  const navigate = useNavigate()

  const [username, setUsername] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [dob, setDob] = useState(
    moment().subtract(18, 'years').toDate()
  )
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [passwordConfirmation, setPasswordConfirmation] = useState("")
  
  const [loading, setLoading] = useState(true)

  const dispatch = useDispatch()
  const state = useSelector(state => state)

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const queryEmail = searchParams.get("email")
    if (queryEmail) {
      setEmail(queryEmail)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    if (localStorage.getItem("user-token")) {
      return navigate("/")
    }
  }, [state.auth,])

  const onFormSubmit = (e) => {
    e.preventDefault()

    dispatch(register({
      dob: moment(dob).format("YYYY-MM-DD"),
      firstName,
      lastName,
      username,
      email,
      password,
      passwordConfirmation,
    }))
  }

  const onUsernameChange = (e) => {
    setUsername(e.target.value)
  }

  const onFirstNameChange = (e) => {
    setFirstName(e.target.value)
  }

  const onLastNameChange = (e) => {
    setLastName(e.target.value)
  }

  const onEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const onPasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const onPasswordConfirmationChange = (e) => {
    setPasswordConfirmation(e.target.value)
  }

  const onDobChange = (e) => {
    setDob(moment(e.target.value).toDate())
  }

  const renderDob = () => {
    return moment(dob).format('DD MMM YYYY')
  }

  if (state.auth.loading || loading) {
    return <>
      <Helmet>
        <title>Create Account - {appName}</title>
      </Helmet>
      <div className="container register-container text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }
  
  return (
    <>
      <Helmet>
        <title>Create Account - {appName}</title>
      </Helmet>
      <div className='container mt-10 mb-8 register-container'>
        <div className="col-md-4 offset-md-4">
          <h3 className="lead register-title">Create Account</h3>
          <form method="post" onSubmit={onFormSubmit}>
            <ErrorComponent error={state.auth.error} />
            <div className="form-group mb-3">
              <label htmlFor="username">
                Username:
              </label>
              <input 
                name="username"
                type="text"
                className="form-control"
                id="username"
                value={username}
                onChange={onUsernameChange}
                placeholder="Enter Username"
                autoComplete='on'
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="firstName">
                First Name:
              </label>
              <input 
                name="firstName"
                type="text"
                className="form-control"
                id="firstName"
                value={firstName}
                onChange={onFirstNameChange}
                placeholder="Enter First Name"
                autoComplete='on'
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="lastName">
                Last Name:
              </label>
              <input 
                name="lastName"
                type="text"
                className="form-control"
                id="lastName"
                value={lastName}
                onChange={onLastNameChange}
                placeholder="Enter Last Name"
                autoComplete='on'
              />
            </div>
            <div className="dob-container">
              <div className='dob-title'>
                <span className='dob-label'>Date of Birth:</span> {renderDob()}
              </div>
              <div className="dob-choose-container text-center">
                <input
                  type="date"
                  name="dob"
                  value={moment(dob).format("YYYY-MM-DD")}
                  onChange={onDobChange}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label htmlFor="email">
                Email:
              </label>
              <input 
                name="email"
                type="text"
                className="form-control"
                id="email"
                value={email}
                onChange={onEmailChange}
                placeholder="Enter Email"
                autoComplete='on'
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="password">
                Password:
              </label>
              <input 
                type="password"
                name="password" 
                className="form-control"
                id="password"
                value={password}
                onChange={onPasswordChange}
                placeholder="Enter Password"
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="passwordConfirmation">
                Password Confirmation:
              </label>
              <input 
                type="password"
                name="passwordConfirmation"
                className="form-control"
                id="passwordConfirmation"
                value={passwordConfirmation}
                onChange={onPasswordConfirmationChange}
                placeholder="Enter Password Confirmation"
              />
            </div>
            <div className="register-btn-container">
              <input 
                type="submit" 
                className="btn btn-success joystick-success"
                value="REGISTER"
              />
            </div>
          </form>
        </div>
      </div>
    </>       
  )
}
